export var ConnectionType;
(function (ConnectionType) {
    ConnectionType[ConnectionType["None"] = 0] = "None";
    ConnectionType[ConnectionType["ImapSmtp"] = 1] = "ImapSmtp";
    ConnectionType[ConnectionType["PopSmtp"] = 2] = "PopSmtp";
    ConnectionType[ConnectionType["SmtpOnly"] = 3] = "SmtpOnly";
})(ConnectionType || (ConnectionType = {}));
//# sourceMappingURL=ConnectionType.js.map